import RectangleButton from '@/components/molecules/rectangleButton'
import Input from './input'
import TextArea from './textarea'
import { useState, useTransition } from 'react'

const Form = () => {
  const [done, setDone] = useState(false)
  const [error, setError] = useState(null)
  const [pending, startTransition] = useTransition()

  async function add(e) {
    e.preventDefault()

    const form = e.currentTarget
    const formData = new FormData(form)
    const payload = Object.fromEntries(formData.entries())

    const res = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
    })
    const data = await res.json()
    if (!res.ok) throw new Error(data.error || 'Gagal mengirim')
    form.reset()
  }

  const onSubmit = (e) => {
    setError(false)
    startTransition(async () => {
      try {
        await add(e)
        setDone(true)
        setTimeout(() => setDone(false), 1500)
      } catch (e) {
        setError(true)
      }
    })
  }

  return (
    <form
      onSubmit={onSubmit}
      className="relative w-full flex flex-col gap-y-[8px] lg:gap-y-smallDesktop mt-mediumMobile lg:mt-mediumDesktop"
    >
      <Input type="text" name="name" placeholder="Name" />
      <Input type="email" name="email" placeholder="Email" />
      <Input type="text" name="subject" placeholder="Subject" />
      <TextArea name="message" placeholder="Message" />
      <RectangleButton
        name={pending ? 'SENDING' : error ? 'ERROR' : done ? 'SENT!' : 'SEND'}
        type="submit"
        disabled={done || pending}
        onClick={() => {}}
        className={`${
          pending
            ? 'pointer-events-none'
            : error
            ? 'pointer-events-none'
            : 'cursor-pointer'
        }`}
      />
    </form>
  )
}

export default Form
